"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ChatBody = exports.AnnotisedMessage = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactIntersectionObserver = require("react-intersection-observer");
var _reactSdk = require("@100mslive/react-sdk");
var _reactUi = require("@100mslive/react-ui");
var _reactIcons = require("@100mslive/react-icons");
var _jsxRuntime = require("react/jsx-runtime");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
var formatTime = function formatTime(date) {
  if (!(date instanceof Date)) {
    return "";
  }
  var hours = date.getHours();
  var mins = date.getMinutes();
  var suffix = hours > 11 ? "PM" : "AM";
  if (hours < 10) {
    hours = "0" + hours;
  }
  if (mins < 10) {
    mins = "0" + mins;
  }
  return "".concat(hours, ":").concat(mins, " ").concat(suffix);
};
var MessageTypeContainer = function MessageTypeContainer(_ref) {
  var left = _ref.left,
    right = _ref.right;
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_reactUi.Flex, {
    align: "center",
    css: {
      ml: "auto",
      mr: "$4",
      p: "$2 $4",
      border: "1px solid $textDisabled",
      r: "$0"
    },
    children: [left && /*#__PURE__*/(0, _jsxRuntime.jsx)(SenderName, {
      variant: "tiny",
      as: "span",
      css: {
        color: "$textMedEmp"
      },
      children: left
    }), left && right && /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactUi.Box, {
      css: {
        borderLeft: "1px solid $textDisabled",
        mx: "$4",
        h: "$8"
      }
    }), right && /*#__PURE__*/(0, _jsxRuntime.jsx)(SenderName, {
      as: "span",
      variant: "tiny",
      children: right
    })]
  });
};
var MessageType = function MessageType(_ref2) {
  var roles = _ref2.roles,
    hasCurrentUserSent = _ref2.hasCurrentUserSent,
    receiver = _ref2.receiver;
  var peerName = (0, _reactSdk.useHMSStore)((0, _reactSdk.selectPeerNameByID)(receiver));
  var localPeerRoleName = (0, _reactSdk.useHMSStore)(_reactSdk.selectLocalPeerRoleName);
  if (receiver) {
    return /*#__PURE__*/(0, _jsxRuntime.jsx)(MessageTypeContainer, {
      left: hasCurrentUserSent ? "".concat(peerName ? "TO ".concat(peerName) : "") : "TO YOU",
      right: "PRIVATE"
    });
  }
  if (roles && roles.length) {
    return /*#__PURE__*/(0, _jsxRuntime.jsx)(MessageTypeContainer, {
      left: "TO",
      right: hasCurrentUserSent ? roles.join(",") : localPeerRoleName
    });
  }
  return null;
};
var URL_REGEX = /^https?:\/\/(www\.)?[-a-zA-Z0-9@:%._+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_+.~#?&//=]*)/;
var Link = (0, _reactUi.styled)("a", {
  color: "$brandDefault",
  wordBreak: "break-word",
  "&:hover": {
    textDecoration: "underline"
  }
});
var AnnotisedMessage = function AnnotisedMessage(_ref3) {
  var message = _ref3.message;
  if (!message) {
    return /*#__PURE__*/(0, _jsxRuntime.jsx)(_react.Fragment, {});
  }
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_react.Fragment, {
    children: message.trim().split(/(\s)/).map(function (part) {
      return URL_REGEX.test(part) ? /*#__PURE__*/(0, _jsxRuntime.jsx)(Link, {
        href: part,
        target: "_blank",
        rel: "noopener noreferrer",
        children: part
      }, part) : part;
    })
  });
};
exports.AnnotisedMessage = AnnotisedMessage;
var getMessageType = function getMessageType(_ref4) {
  var roles = _ref4.roles,
    receiver = _ref4.receiver;
  if (roles && roles.length > 0) {
    return "role";
  }
  return receiver ? "private" : "";
};
var ChatActions = function ChatActions(_ref5) {
  var onPin = _ref5.onPin;
  var _useState = (0, _react.useState)(false),
    _useState2 = _slicedToArray(_useState, 2),
    open = _useState2[0],
    setOpen = _useState2[1];
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_reactUi.Dropdown.Root, {
    open: open,
    onOpenChange: setOpen,
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_reactUi.Dropdown.Trigger, {
      asChild: true,
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactUi.IconButton, {
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactUi.Tooltip, {
          title: "More options",
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactUi.Box, {
            children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactIcons.HorizontalMenuIcon, {})
          })
        })
      })
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactUi.Dropdown.Content, {
      sideOffset: 5,
      align: "center",
      css: {
        width: "$48"
      },
      children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_reactUi.Dropdown.Item, {
        "data-testid": "pin_message_btn",
        onClick: onPin,
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_reactIcons.PinIcon, {}), /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactUi.Text, {
          variant: "sm",
          css: {
            ml: "$4"
          },
          children: "Pin Message"
        })]
      })
    })]
  });
};
var SenderName = (0, _reactUi.styled)(_reactUi.Text, {
  overflow: "hidden",
  textOverflow: "ellipsis",
  whiteSpace: "nowrap",
  maxWidth: "24ch",
  minWidth: 0
});
var ChatMessage = /*#__PURE__*/_react["default"].memo(function (_ref6) {
  var message = _ref6.message,
    _ref6$autoMarginTop = _ref6.autoMarginTop,
    autoMarginTop = _ref6$autoMarginTop === void 0 ? false : _ref6$autoMarginTop,
    onPin = _ref6.onPin;
  var _useInView = (0, _reactIntersectionObserver.useInView)({
      threshold: 0.5,
      triggerOnce: true
    }),
    ref = _useInView.ref,
    inView = _useInView.inView;
  var hmsActions = (0, _reactSdk.useHMSActions)();
  var localPeerId = (0, _reactSdk.useHMSStore)(_reactSdk.selectLocalPeerID);
  var permissions = (0, _reactSdk.useHMSStore)(_reactSdk.selectPermissions);
  var messageType = getMessageType({
    roles: message.recipientRoles,
    receiver: message.recipientPeer
  });
  // show pin action only if peer has remove others permission and the message is of broadcast type
  var showPinAction = permissions.removeOthers && !messageType;
  (0, _react.useEffect)(function () {
    if (message.id && !message.read && inView) {
      hmsActions.setMessageRead(true, message.id);
    }
  }, [message.read, hmsActions, inView, message.id]);
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_reactUi.Flex, {
    ref: ref,
    align: "center",
    css: {
      flexWrap: "wrap",
      bg: messageType ? "$surfaceLight" : undefined,
      px: messageType ? "$4" : "$2",
      py: messageType ? "$4" : 0,
      r: "$1",
      mb: "$10",
      mt: autoMarginTop ? "auto" : undefined
    },
    "data-testid": "chat_msg",
    children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(_reactUi.Text, {
      css: {
        color: "$textHighEmp",
        fontWeight: "$semiBold",
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "space-between",
        width: "100%"
      },
      as: "div",
      children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(_reactUi.Flex, {
        align: "center",
        children: [message.senderName === "You" || !message.senderName ? /*#__PURE__*/(0, _jsxRuntime.jsx)(SenderName, {
          as: "span",
          children: message.senderName || "Anonymous"
        }) : /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactUi.Tooltip, {
          title: message.senderName,
          side: "top",
          align: "start",
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(SenderName, {
            as: "span",
            children: message.senderName
          })
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactUi.Text, {
          as: "span",
          variant: "sm",
          css: {
            ml: "$4",
            color: "$textSecondary",
            flexShrink: 0
          },
          children: formatTime(message.time)
        })]
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(MessageType, {
        hasCurrentUserSent: message.sender === localPeerId,
        receiver: message.recipientPeer,
        roles: message.recipientRoles
      }), showPinAction && /*#__PURE__*/(0, _jsxRuntime.jsx)(ChatActions, {
        onPin: onPin
      })]
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactUi.Text, {
      variant: "body2",
      css: {
        w: "100%",
        mt: "$2",
        wordBreak: "break-word",
        whiteSpace: "pre-wrap"
      },
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(AnnotisedMessage, {
        message: message.message
      })
    })]
  }, message.time);
});
var ChatBody = function ChatBody(_ref7) {
  var role = _ref7.role,
    peerId = _ref7.peerId,
    setPinnedMessage = _ref7.setPinnedMessage;
  var storeMessageSelector = role ? (0, _reactSdk.selectMessagesByRole)(role) : peerId ? (0, _reactSdk.selectMessagesByPeerID)(peerId) : _reactSdk.selectHMSMessages;
  var messages = (0, _reactSdk.useHMSStore)(storeMessageSelector) || [];
  if (messages.length === 0) {
    return /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactUi.Flex, {
      css: {
        width: "100%",
        height: "calc(100% - 1px)",
        textAlign: "center",
        px: "$4"
      },
      align: "center",
      justify: "center",
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactUi.Text, {
        children: "There are no messages here"
      })
    });
  }
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_react.Fragment, {
    children: messages.map(function (message, index) {
      return /*#__PURE__*/(0, _jsxRuntime.jsx)(ChatMessage, {
        message: message,
        autoMarginTop: index === 0,
        onPin: function onPin() {
          return setPinnedMessage(message);
        }
      }, message.id);
    })
  });
};
exports.ChatBody = ChatBody;